import type { MediaCropArea } from '#src/app/shared/hooks/imageUpload';
import { MIN_IMAGE_DIMENSION_SIZE } from '#src/app/shared/hooks/uppyUploader';

export const validateImageSize = (imageData?: MediaCropArea): boolean =>
	imageData ? imageData.h > MIN_IMAGE_DIMENSION_SIZE.HEIGHT || imageData.w > MIN_IMAGE_DIMENSION_SIZE.WIDTH : false;
